import { create } from 'zustand';

import type { Platform } from '@/types/navigation';

type NavigationState = {
  platforms: Platform[];
  expanded: Set<string>;
  sidebarCollapsed: boolean;
  mobileMenuOpen: boolean;
};

type NavigationActions = {
  registerPlatform: (platform: Platform) => void;
  toggle: (id: string) => void;
  toggleSidebar: () => void;
  setMobileMenu: (open: boolean) => void;
};

type NavigationStore = NavigationState & NavigationActions;

export const useNavigationStore = create<NavigationStore>((set) => ({
  platforms: [],
  expanded: new Set<string>(),
  sidebarCollapsed: false,
  mobileMenuOpen: false,

  registerPlatform: (platform): void =>
    set((s) => {
      if (s.platforms.some((p) => p.id === platform.id)) {
        return {};
      }
      const exp = new Set(s.expanded);
      exp.add(platform.id);
      platform.features.forEach((f) => exp.add(f.id));
      return { platforms: [...s.platforms, platform], expanded: exp };
    }),

  toggle: (id): void =>
    set((s) => {
      const exp = new Set(s.expanded);
      exp.has(id) ? exp.delete(id) : exp.add(id);
      return { expanded: exp };
    }),

  toggleSidebar: (): void =>
    set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setMobileMenu: (open): void => set({ mobileMenuOpen: open }),
}));
